import React from 'react';
import { BannerHowItWorksBody } from '@cp/entities/catalog';
import { Typography } from '@cp/ds/src/components/typography';
import { useIsMobile, useTheme } from '@cp/ds/src/hooks';
import { useClientWebRouteParams } from '@cp/entities/clientWebRoutes';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { coreCareerApi } from '@cp/entities/career';
import { Image as Img } from '@cp/ui';
import imgDesktop3 from './assets/desktop_3.webp';
import imgDesktop2 from './assets/desktop_2.webp';
import imgDesktop1 from './assets/desktop_1.webp';
import imgMobile3 from './assets/mobile_3.webp';
import imgMobile2 from './assets/mobile_2.webp';
import imgMobile1 from './assets/mobile_1.webp';

export const BannerHowItWorksWidget = () => {
  const theme = useTheme();
  const isMobile = useIsMobile();
  const {
    pageProps: { careerId },
  } = useClientWebRouteParams<ClientWebPage.Catalog>();
  const { data: careerDictionary } = coreCareerApi.endpoints.getCareers.useQuery();

  const careerName = React.useMemo(() => {
    if (!careerDictionary) {
      return 'специалисты';
    }
    return careerDictionary[careerId].translation.namePlural;
  }, [careerDictionary, careerId]);

  return (
    <BannerHowItWorksBody
      items={[
        {
          body: (
            <>
              <Typography variant="h2">
                <Typography sx={{ color: theme.palette['brand pink'] }} variant="h2">
                  Надежные{' '}
                </Typography>
                {careerName}
              </Typography>
              <Typography component="p">
                Каждый специалист проходит <Typography variant="body bold">личное собеседование/обучение</Typography> и проверку документов.
              </Typography>
            </>
          ),
          backgroundImage: <Img src={isMobile ? imgMobile1 : imgDesktop1} />,
        },
        {
          body: (
            <Typography variant="h2">
              Выбирайте лучших <br />
              <Typography sx={{ color: theme.palette['brand pink'] }} variant="h2">
                по отзывам
              </Typography>
            </Typography>
          ),
          backgroundImage: <Img src={isMobile ? imgMobile2 : imgDesktop2} />,
        },
        {
          body: (
            <Typography variant="h2">
              Ищите без{' '}
              <Typography sx={{ color: theme.palette['brand pink'] }} variant="h2">
                посредников{' '}
              </Typography>
              <br />и переплат
            </Typography>
          ),
          backgroundImage: <Img src={isMobile ? imgMobile3 : imgDesktop3} />,
        },
      ]}
    />
  );
};
